// extracted by mini-css-extract-plugin
module.exports = {"root":"FlexibleImageCTA_root__bsP_R","ctaContent":"FlexibleImageCTA_ctaContent__3oL6R","header":"FlexibleImageCTA_header__j0Gbv","cta":"FlexibleImageCTA_cta__quvAV"};